import dayjs from 'dayjs';
import { parse } from 'mathjs';
import toast from 'react-hot-toast';
import { parseISO, startOfDay } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { isCombosEnabled } from './featureFlags';

export const toastText = (message: string, type: string) => {
	switch (type) {
		case 'success':
			toast.success(message, {
				style: {
					fontSize: '16px',
				},
			});

			break;

		case 'error':
			toast.error(message, {
				style: {
					fontSize: '16px',
				},
			});
			break;
	}
};

export function invalidText(value: string | number | null | undefined) {
	return (
		value === null ||
		value === undefined ||
		value.toString().trim().length === 0
	);
}

export function base64ToBlob(base64: string, mime: string) {
	const byteCharacters = atob(base64);
	const arrayBuffer = new ArrayBuffer(byteCharacters.length);
	const uint8Array = new Uint8Array(arrayBuffer);
	for (let i = 0; i < byteCharacters.length; i++) {
		uint8Array[i] = byteCharacters.charCodeAt(i);
	}
	return new Blob([uint8Array], { type: mime });
}

export const deepCopy = (obj: any) => {
	return JSON.parse(JSON.stringify(obj));
};

export const formatPhoneNumber = (phoneNumber: string) => {
	// Remove all non-numeric characters from the input
	const cleanedNumber = phoneNumber.replace(/\D/g, '');

	// Define the phone number format (e.g., "(XXX) XXX-XXXX")
	const format = '($1) $2-$3';

	// Apply the mask to the cleaned number using a regular expression
	const maskedNumber = cleanedNumber.replace(/(\d{3})(\d{3})(\d{4})/, format);

	return maskedNumber;
};

export const phoneNumberFormatHandler = (phoneNumber: any = '') => {
	const inputPhoneNumber = phoneNumber?.replace(/\D/g, ''); // Remove non-digit characters
	let formattedPhoneNumber = '';

	if (inputPhoneNumber.length > 0) {
		formattedPhoneNumber = `(${inputPhoneNumber.slice(0, 3)}`;

		if (inputPhoneNumber.length >= 4) {
			formattedPhoneNumber += `) ${inputPhoneNumber.slice(3, 6)}`;
		}

		if (inputPhoneNumber.length >= 7) {
			formattedPhoneNumber += `-${inputPhoneNumber.slice(6, 10)}`;
		}
	}

	return formattedPhoneNumber;
};

export const getPeriodCategory = (hubspotDate: any) => {
	const today: any = new Date();

	const millisecondsPerWeek = 1000 * 60 * 60 * 24 * 7;

	const timeDifferenceInWeeks = Math.round(
		(today - hubspotDate) / millisecondsPerWeek
	);

	let category = '';

	if (timeDifferenceInWeeks <= 4) {
		category = '1st 4 weeks';
	} else if (timeDifferenceInWeeks <= 6) {
		category = '4 weeks until 6 weeks';
	} else if (timeDifferenceInWeeks <= 8) {
		category = '6 weeks until 8 weeks';
	} else if (timeDifferenceInWeeks <= 12) {
		category = '8 weeks until 12 weeks';
	} else if (timeDifferenceInWeeks <= 24) {
		category = '12 weeks until 24 weeks';
	} else if (timeDifferenceInWeeks <= 36) {
		category = '24 weeks until 36 weeks';
	} else if (timeDifferenceInWeeks <= 52) {
		category = '36 weeks until 52 weeks';
	} else {
		category = 'More than 52 weeks';
	}
	return category;
};

export const addCommasToNumber = (number: any) => {
	if (number) {
		const parts = number?.toString().split('.');
		if (parts && parts.length > 0) {
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return parts.join('.');
		}
	} else {
		return '0';
	}
};

export const getPermissionObject = (
	permissionObj: any,
	allPermissions: any
) => {
	let formattedArray: any = [];
	const updatedAllPermission = allPermissions.map((singlePermission: any) => {
		return {
			...singlePermission,
			isBold: false,
		};
	});

	// const updatedPermissionObj = []
	for (const singlePermissionObj of permissionObj) {
		let tempArray = [];
		if (singlePermissionObj.name) {
			tempArray.push({
				moduleName: singlePermissionObj.name,
				isBold: true,
			});
		}

		const filteredPermissions = updatedAllPermission.filter(
			(singlePermission: any) => {
				return singlePermissionObj.items.includes(
					singlePermission.sortId
				);
			}
		);
		tempArray = [...tempArray, ...filteredPermissions];
		formattedArray = [...formattedArray, ...tempArray];
	}

	return formattedArray;
};

export const checkPermission = (
	allPermissions: any,
	requiredPermission: any
) => {
	if (!allPermissions) {
		return false;
	}
	const permissionsList = allPermissions;
	const permission = permissionsList?.find(
		(singlePermission: any) =>
			singlePermission.moduleName === requiredPermission.permissionName
	);

	if (permission) {
		const permitted = requiredPermission.permission.some(
			(singlePermission: string) => permission[singlePermission]
		);
		return permitted || permission['all'];
	} else {
		return false;
	}
};
export function getAllowedModule(permissions: any, modules: any) {
	let _moduleName = null;
	for (let module of modules) {
		const _module = permissions?.find(
			(per: any) => per.moduleName === module
		);

		if (_module) {
			const {
				moduleName,
				add,
				view,
				edit,
				approval,
				delete: del,
			} = _module;

			if (add || view || edit || del || approval) {
				_moduleName = moduleName;
				break;
			}
		}
	}

	return _moduleName;
}


export const permissionObject = [
	{
		items: [1, 2],
	},
	{
		name: 'Dashboard',
		items: [3],
	},
	{
		name: 'Images',
		items: [4],
	},
	{
		name: 'Categories',
		items: [5],
	},
	{
		name: 'Sub Categories',
		items: [6],
	},
	{
		name: 'Medicines',
		items: [7],
	},
	{
		name: 'Dose forms',
		items: [8],
	},
	{
		name : 'Warning Tags',
		items: [9]
	},
	{
		name : 'Quality Check',
		items: [10]
	},
	{
		name: 'Rejected',
		items: [11]
	},
	{
		name: 'Category Dose Form Mapping',
		items: [12]
	},
	{
		name: 'Draft Medicines Request',
		items: [13],
	},
	{
		name: 'Grocery Items',
		items: [14],
	},
	{
		name: 'Grocery Categories',
		items: [15],
	},
	{
		name: 'Grocery Sub Categories',
		items: [16],
	},
	{
		name: 'Grocery Quality Check',
		items: [17],
	},
	{
		name: 'Grocery Rejected',
		items: [18],
	},
	{
		name: 'Grocery Items User Filter',
		items: [23],
	},
	{
		name: 'Combo Items',
		items: [19],
	},
	{
		name: 'Combo Categories',
		items: [20],
	},
	{
		name: 'Combo Sub Categories',
		items: [21],
	},
	{
		name: 'Combo Quality Check',
		items: [22],
	},
];

const COMBO_PERMISSION_SORT_IDS = [19, 20, 21, 22];

export const getPermissionObjectForUi = () => {
	if (isCombosEnabled()) {
		return permissionObject;
	}
	return permissionObject
		.map((section) => {
			if (!section.items) {
				return section;
			}
			const items = section.items.filter(
				(id: number) => !COMBO_PERMISSION_SORT_IDS.includes(id),
			);
			if (items.length === 0) {
				return null;
			}
			return { ...section, items };
		})
		.filter(Boolean);
};


export function validateFormData(
	dataObj: { [key: string]: any },
	errObj: { [key: string]: boolean }
): { [key: string]: boolean } {
	Object.keys(dataObj).forEach((key) => {
		if (Object.hasOwn(errObj, key)) {
			errObj[key] = invalidText(dataObj[key]);
		}
	});

	return errObj;
}

export function hasFormError(errObj: { [key: string]: boolean }): boolean {
	return Object.keys(errObj).some((key) => {
		return errObj[key];
	});
}
export const configurationModules = [
	'branch code',
	'category code',
	'company',
	'departments',
	'pay point',
	'job grade',
	'cost center',
	'job title',
	// 'earning',
	// 'deduction',
	'holidays',
	'leave management',
];
export const payrollSettingsModules = [
	'company setup',
	'pay period',
	'pay schedule',
	'payroll history',
	'statutory components',
	'mid-month pay',
	'deduction code',
	'earning code',
];
export function getAllowedPermissions(modules: any) {
	let allowedPermissions: any = [];

	let allowConfiguration = false;
	let allowPayrollSettings = false;
	modules?.forEach((module: any) => {
		const { moduleName, add, view, edit, approval, delete: del } = module;

		const _moduleName =
			moduleName.split(' ').length > 1
				? moduleName.split(' ')?.join('_')
				: moduleName;
		if (add) {
			allowedPermissions.push(`Add_${_moduleName}`);
		}
		if (edit) {
			allowedPermissions.push(`Edit_${_moduleName}`);
		}
		if (del) {
			allowedPermissions.push(`Delete_${_moduleName}`);
		}
		if (view) {
			allowedPermissions.push(`View_${_moduleName}`);
		}
		if (approval) {
			allowedPermissions.push(`Approval_${_moduleName}`);
		}
		if (add || view || edit || del || approval) {
			allowedPermissions.push(`Allow_${_moduleName}`);
		}
		if (
			configurationModules.includes(moduleName.toLowerCase()) &&
			(add || view || edit || del || approval)
		) {
			allowConfiguration = true;
		}
		if (
			payrollSettingsModules.includes(moduleName.toLowerCase()) &&
			(add || view || edit || del || approval)
		) {
			allowPayrollSettings = true;
		}
	});
	if (allowPayrollSettings) {
		allowedPermissions.push(`Allow_Payroll_Settings`);
	}
	if (allowConfiguration) {
		allowedPermissions.push(`Allow_Configuration`);
	}

	return allowedPermissions;
}


export function formatChanges(changes: any) {
	if (!changes || typeof changes !== 'object') {
		throw new Error('Invalid input: changes must be an object');
	}

	// Destructure the message property from the changes object
	const { message } = changes;

	if (!message || typeof message !== 'object') {
		throw new Error('Invalid input: changes.message must be an object');
	}

	// Map over the entries of the message object and create a formatted string for each change
	const formattedChanges = Object.entries(message)
		.map(([field, item]: any) => {
			let oldValue = item?.oldValue;
			let newValue = item?.newValue;

			if (
				field === 'dateOfBirth' ||
				field === 'joiningDate' ||
				field === 'terminationDate'
			) {
				if (oldValue && oldValue !== 'NA') {
					oldValue = dayjs(oldValue).format('DD/MM/YYYY');
					newValue = dayjs(newValue).format('DD/MM/YYYY');
				} else {
					oldValue = 'NA';
					newValue = dayjs(newValue).format('DD/MM/YYYY');
				}
			}

			if (item.isSelectField) {
				oldValue = item?.oldValueName;
				newValue = item?.newValueName;
			}

			return `${
				fieldNameMapping[field as keyof typeof fieldNameMapping]
			} <span class="color-purple">from </span> ${oldValue} <span class="color-purple">to</span> ${newValue}`;
		})
		.join('<span class="color-purple">, </span> ');

	return formattedChanges;
}

export const fieldNameMapping = {
	firstName: 'First Name',
	lastName: 'Last Name',
	dateOfBirth: 'Date of Birth',
	gender: 'Gender',
	country: 'Country',
	maritalStatus: 'Marital Status',
	joiningDate: 'Joining Date',
	branchId: 'Branch ID',
	branch: 'Branch Code',
	departmentId: 'Department ID',
	department: 'Department',
	costCenterId: 'Cost Center ID',
	costCenter: 'Cost Center',
	categoryId: 'Category ID',
	category: 'Category',
	jobGradeId: 'Job Grade ID',
	jobGrade: 'Job Grade',
	staffCode: 'Staff Code',
	ssn: 'SSN',
	passportNo: 'Passport Number',
	nationalRegistrationNo: 'National Registration Number',
	recordStatus: 'Record Status',
	employeeTPIN: 'Employee TPIN',
	currency: 'Currency',
	taxationMethod: 'Taxation Method',
	employmentType: 'Employment Type',
	isCompensationFund: 'Is Compensation Fund',
	napsaPaidBy: 'NAPSA Paid By',
	enableGrossUpTax: 'Enable Gross Up Tax',
	disabilities: 'Disabilities',
	grossUpAllEarnings: 'Gross Up All Earnings',
	terminationDate: 'Termination Date',
	earnings: 'Earnings',
	monthlySalary: 'Monthly Salary',
	hourlySalary: 'Hourly Salary',
	midMonthSalary: 'Mid Month Salary',
	effectiveStartDate: 'Effective Date',
	notes: 'Notes',
	'Salary Details': 'Monthly Salary',
	supervisorIds: 'Supervisor',
};

export const sectionMapping = {
	PERSONAL_DETAILS: 'Personal Details',
	TAXATION_DETAILS: 'Taxation Details',
	EMPLOYEE_DETAILS: 'Employee Details',
	IDENTIFICATION_DETAILS: 'Identification Details',
	EARNINGS: 'Earnings',
	SALARY_DETAILS: 'Salary Details',
};

export const taxationMethodMapping = {
	CONTRIBUTE_TO_CHARITY: 'Contribute to Charity',
	CUMULATIVE_BASIS: 'Cumulative Basis',
	DAILY_TAX: 'Daily Tax',
	TAX_EXEMPT: 'Tax Exempt',
};

export function formatToDateOnly(date: any) {
	// Convert to Day.js object and set the time to 00:00:00
	const dateOnly = dayjs(date).startOf('day');
	// Format to date-only string (e.g., 'YYYY-MM-DD')
	return dateOnly.format('YYYY-MM-DD');
}
export const removeEmptyValues = (obj: any) => {
	return Object.fromEntries(
		Object.entries(obj).filter(
			([_, value]) => value !== null && value !== undefined
		)
	);
};

export function extractVariables(node: any, variables = new Set<string>()) {
	if (node.isSymbolNode) {
		variables.add(node.name);
	} else if (node.args) {
		node.args.forEach((arg: any) => extractVariables(arg, variables));
	}

	return Array.from(variables); // Convert Set to an array using Array.from()
}
export const validateFormula = (
	formula: string,
	allowedVariables: string[]
): boolean => {
	try {
		const node = parse(formula);
		const variables = extractVariables(node);

		for (const variable of variables) {
			if (!allowedVariables.includes(variable)) {
				return false;
			}
		}

		return true;
	} catch (error) {
		return false;
	}
};

export const allowedVariablesForEarningsFormula = ['SAL', 'OTH'];

export function compareArrays(array1: any, array2: any) {
	const map2 = new Map(array2.map((obj: any) => [obj.id, obj]));

	function objectsDiffer(obj1: any, obj2: any) {
		for (const key in obj1) {
			if (obj1[key] !== obj2[key]) {
				return true;
			}
		}
		return false;
	}

	const differingObjectsFromArray1: any = [];
	const differingObjectsFromArray2: any = [];

	array1.forEach((obj1: any) => {
		const obj2 = map2.get(obj1.id);
		if (obj2 && objectsDiffer(obj1, obj2)) {
			differingObjectsFromArray1.push(obj1);
			differingObjectsFromArray2.push(obj2);
		}
	});

	return {
		fromArray1: differingObjectsFromArray1,
		fromArray2: differingObjectsFromArray2,
	};
}

export function compareObjects(obj1: any, obj2: any) {
	// Array to store the differences
	const differences: any = [];

	// Get all keys from both objects
	const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

	// Iterate through each key
	allKeys.forEach((key) => {
		const value1 = obj1[key];
		const value2 = obj2[key];

		// Check if the values are different
		if (value1 !== value2) {
			differences.push({ key, value1, value2 });
		}
	});

	return differences;
}

export function timeStringToMinutes(timeString: string) {
	const [hours, minutes] =
		!invalidText(timeString) && timeString?.includes(':')
			? timeString.split(':').map(Number)
			: [0, 0];
	return hours * 60 + minutes;
}

export function minutesToTimeString(totalMinutes: number) {
	const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
	const minutes = String(totalMinutes % 60).padStart(2, '0');
	return `${hours}:${minutes}`;
}

export const formatDateToDisplay = (isoString: string) => {
	const utcDate = parseISO(isoString);
	const startOfUTCDate = startOfDay(utcDate); // Set time to 00:00:00
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get user's local time zone

	// Format the date in the user's local time zone
	const formattedDate = formatInTimeZone(
		startOfUTCDate,
		timeZone,
		'dd/MM/yyyy'
	);

	return formattedDate;
};
